import { Card, Stack, CardHeader, Divider, CardContent, Typography } from "@mui/material";
import React from "react";

export default function CustomerBriefing(props: { customer_briefing: any }) {
    const { customer_briefing } = props;
    return (
        <React.Fragment>
            {customer_briefing && customer_briefing.length > 0 ? (
            <Card sx={{
                maxHeight: 370, 
                height: '100%', 
                borderRadius: '6px !important', 
                border: 0,
                boxShadow: 'none',
                marginTop: window.innerWidth > 1200 ? -5 : 0,
                // boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.1)'
            }}>
                <CardHeader title="Customer Briefing"  slotProps={{ title: { sx: { fontSize: '1rem !important' } } }}/>
                <Divider />
                <CardContent>
                    <Stack direction="column" spacing={0.6} sx={{ width: '100%', height: 300, overflowY: 'auto' }}>
                        {customer_briefing.length > 0 && customer_briefing.map((briefing: any, index: number) => (
                            <Typography sx={{ fontSize: '0.75rem !important' }} key={index}>{briefing}</Typography>
                        ))}
                    </Stack>
                </CardContent>
            </Card>
        ) : (
            <Card sx={{
                maxHeight: 300, 
                height: 'auto', 
                borderRadius: '6px !important', 
                border: 0,
                boxShadow: 'none',
                marginTop: window.innerWidth > 1200 ? -7 : 0,
                // boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.1)'
            }}>
                <CardHeader title="Customer Briefing"  slotProps={{ title: { sx: { fontSize: '1rem !important' } } }} />
                <Divider />
                <CardContent>
                    <Typography variant="body1" sx={{ color: 'text.secondary', textAlign: 'center' }}>No data available</Typography>
                </CardContent>
            </Card>
        )}
        </React.Fragment>
    );
}
 